export const unitwiseColumns = [
  {
    Header: "Hotel Name",
    accessor: "hotelName",
  },
  {
    Header: "No of Booking",
    accessor: "noBooking",
  },
  {
    Header: "Actions",
    accessor: "actions",
  },
  
];

export const unitwiseviewColumns = [
  { Header: "Sl#", accessor: "Sl" },
  { Header: "Date", accessor: "Date" },
  { Header: "No of Booking", accessor: "NoofBooking" },
  { Header: "Total No. of Room", accessor: "TotalNoofRoom" },
  { Header: "Actions", accessor: "actions" },
];

export const getUnitwiseViewColumns = (handleBookingClick) => [
  { Header: "Sl#", accessor: "Sl" },
  {
    Header: "Booking Id",
    accessor: "BookingID",
    Cell: ({ row }) => {
      const bookingId = row.original.BookingID;
      return (
        <span
          onClick={() => handleBookingClick(row.original)}
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {bookingId}
        </span>
      );
    },
  },

  { Header: "Booking Date & Time", accessor: "BookingDateTime" },
  { Header: "Booking Ref No", accessor: "BookingRefNo" },
    { Header: "Customer Name", accessor: "CustomerName" },
  { Header: "Customer Mobile", accessor: "CustomerMobile" },
  { Header: "Check-In Date", accessor: "CheckinDate" },
  { Header: "Check-Out Date", accessor: "CheckoutDate" },
  { Header: "Room Type", accessor: "RoomType" },
  { Header: "Rooms Booked", accessor: "NoOfRooms" },
  { Header: "Total Amount", accessor: "TotalAmount" },
  { Header: "Booked By", accessor: "BookedBy" },
  { Header: "Email ID", accessor: "EmailID" },
];

